import Vue from 'vue'
// import ElementUI from 'element-ui'
import {
  Tooltip,
  Drawer,
  Button,
  Progress,
  Form,
  FormItem,
  Input,
  InputNumber,
  Row,
  Col,
  Tabs,
  TabPane,
  Select,
  Option,
  DatePicker,
  Menu,
  MenuItem,
  Submenu,
  Checkbox,
  Link,
  Slider,
  Message,
  MessageBox,
  Radio,
  Tag,
  RadioGroup,
  Notification,
  Empty,
  Descriptions,
  DescriptionsItem,
  Divider,
  Container,
  Main,
  Timeline,
  TimelineItem,
  Card,
  Autocomplete,
  Pagination
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)
Vue.use(Card)
Vue.use(Tooltip)
Vue.use(Drawer)
Vue.use(Button)
Vue.use(Progress)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Checkbox)
Vue.use(Link)
Vue.use(Slider)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(RadioGroup)
Vue.use(Empty)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Divider)
Vue.use(Container)
Vue.use(Main)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Autocomplete)
Vue.use(Pagination)
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$messagebox = MessageBox
Vue.prototype.$notify = Notification
Vue.prototype.$message = function(msg) {
  if (!('showClose' in msg)) {
    msg['showClose'] = true
  }
  // if (!('duration' in msg)) {
  //     msg['duration'] = 1000
  // }
  Message(msg)
}
let messagearr = ['success', 'warning', 'info', 'error']
messagearr.forEach(function(type) {
  Vue.prototype.$message[type] = function(options) {
    if (options.constructor === Object) {
      options['type'] = type
      if (!('showClose' in options)) {
        options['showClose'] = true
      }
      // if (!('duration' in options)) {
      //     options['duration'] = 1000
      // }
      return Message(options)
    } else {
      let option = {
        message: options,
        type: type,
        showClose: true
      }
      return Message(option)
    }
  }
})
